import { sortBy } from "lodash-es";
import { SiteDTO } from "mock-api/src/shared-v2-types/site.types";
import { SiteAvailabilityStatus } from "src/app/core/constants";
import { Partner } from "src/app/partner/global/partner.model";
import { getEnumMember } from "src/utils";
import { SiteReference } from "./site.model";

export class SiteSummary implements SiteReference {
  private constructor(args: ClassProperties<SiteSummary>) {
    this.id = args.id;
    this.name = args.name;
    this.number = args.number;
    this.status = args.status;
    this.partner = args.partner;
  }

  public readonly id: SiteReference["id"];
  public readonly name: string;
  public readonly number: number;
  public readonly status: SiteAvailabilityStatus;
  public readonly partner: Partner;

  public static deserialize(
    data: Omit<SiteDTO, "role">,
    { partner }: { partner: Partner },
  ): SiteSummary {
    return new SiteSummary({
      id: data.id,
      name: data.displayName || data.name,
      number: data.masterSiteId,
      status: getEnumMember(SiteAvailabilityStatus, data.status),
      partner,
    });
  }

  public static deserializeList(
    data: readonly SiteDTO[],
    args: { partner: Partner },
  ): readonly SiteSummary[] {
    // Sorted here as well as after a local save: the API orders with .NET
    // collation, which disagrees with this comparison outside ASCII.
    return sortSiteSummaries(
      data.map((row) => SiteSummary.deserialize(row, args)),
    );
  }
}

export function sortSiteSummaries(
  rows: readonly SiteSummary[],
): readonly SiteSummary[] {
  return sortBy(rows, (site) => site.name.toLowerCase());
}
